import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API } from "@/lib/api";
import { Card } from "@/components/ui/card";
import OpportunityReport from "@/components/OpportunityReport";

export default function PublicPacket() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    fetch(`${API}/public/packets/${token}/report`)
      .then(async r => {
        if (r.status === 410) { setErr("This share link has expired."); return null; }
        if (!r.ok) { setErr("Link not found."); return null; }
        return r.json();
      })
      .then(setData)
      .catch(() => setErr("Unable to load report."));
  }, [token]);

  if (err) return (
    <div className="min-h-screen bg-[#F8FAF9] flex items-center justify-center p-6">
      <Card className="p-8 border-slate-200 max-w-md w-full text-center">
        <div className="text-slate-900 font-semibold mb-1">Link unavailable</div>
        <div className="text-sm text-slate-500">{err}</div>
      </Card>
    </div>
  );
  if (!data) return <div className="min-h-screen flex items-center justify-center text-sm text-slate-500">Loading…</div>;
  return <OpportunityReport data={data} mode="external" />;
}
